<template>
  <div>
    <section class="content-header">
      <h1>{{ $t('search_list') }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">
          <api-table
              entity="Search"
              route="search"
              path="search"
              :filterable="filterable"
              :columns="columns"
              :templates="templates"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import ApiTable from '../components/ApiTable'
  import q from './../table/ColumnQ'

  export default {
    components: { ApiTable },
    data: function() {
      return {
        columns: ['q', 'type'],
        filterable: ['q', 'type'],
        templates: {
          q
        }
      }
    }
  }
</script>
